import {Base} from "@/api/Base"

export class LeaveTypeEdit extends Base {
    path = "leaveType/edit"
}